import React, { forwardRef } from "react";
import AddBox from "@material-ui/icons/AddBox";
import Check from "@material-ui/icons/Check";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Edit from "@material-ui/icons/Edit";
import SaveAlt from "@material-ui/icons/SaveAlt";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import Search from "@material-ui/icons/Search";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Remove from "@material-ui/icons/Remove";
import ViewColumn from "@material-ui/icons/ViewColumn";
import MaterialTable from "material-table";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  TablePagination,
} from "@material-ui/core";
import { generatePdf } from "../../../utility/PdfGenerator/PdfGenerator";
import { generateXlsx } from "../../../utility/XlsxGenerator/XlsxGenerator";
import { withRouter } from "react-router";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import momentJalai from "moment-jalaali";
import pageSizeOptions from "../../../utility/Pagination/pageSizeOptions";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

function parseRangeSearch(searchText) {
  if (!searchText || typeof searchText !== "string") return null;
  const trimmed = searchText.trim();
  // Match patterns: "1930-45", "1930-1945", "1930 - 45"
  const match = trimmed.match(/^(\d+)\s*-\s*(\d+)$/);
  if (!match) return null;
  const from = parseInt(match[1], 10);
  const to = parseInt(match[2], 10);
  if (isNaN(from) || isNaN(to)) return null;
  // If second number is shorter (e.g. "45"), assume same century as first
  const fullTo = match[2].length < match[1].length
    ? parseInt(match[1].slice(0, match[1].length - match[2].length) + match[2], 10)
    : to;
  return { from: Math.min(from, fullTo), to: Math.max(from, fullTo) };
}

const MaterialTableRtl = (props) => {
  const [openRemove, setOpenRemove] = React.useState(false);
  const [selectRemove, setSelectRemove] = React.useState(null);
  const {
    data,
    columns,
    needExport,
    title,
    handleRemove,
    editLink,
    detailPanel,
    pdfOrientation,
    pdfName
  } = props;

  const enhancedColumns = React.useMemo(() => {
    return columns.map((col) => {
      if (col.customFilterAndSearch) return col;
      return {
        ...col,
        customFilterAndSearch: (filterValue, row, columnDef) => {
          const range = parseRangeSearch(filterValue);
          if (range) {
            const cellVal = row[columnDef.field];
            const num = parseFloat(cellVal);
            if (!isNaN(num) && num >= range.from && num <= range.to) return true;
            return false;
          }
          // Normal text search for non-range queries
          const cellVal = row[columnDef.field];
          if (cellVal == null) return false;
          return String(cellVal).toLowerCase().includes(String(filterValue).toLowerCase());
        },
      };
    });
  }, [columns]);

  return (
    <div style={{ direction: "rtl", maxWidth: "100%" }}>
      <MaterialTable
        tableRef={props.tableRef}
        icons={tableIcons}
        localization={{
          pagination: {
            labelDisplayedRows: "{from}-{to} از {count}",
            labelRowsSelect: "داده",
          },
          toolbar: {
            searchPlaceholder: "جستجو",
            exportTitle: "تولید خروجی",
            exportCSVName: "خروجی اکسل",
            exportPDFName: "خروجی PDF",
          },
          header: {
            actions: "عملیات",
          },
          body: {
            emptyDataSourceMessage: "اطلاعاتی پیدا نشد",
          },
        }}
        columns={enhancedColumns}
        detailPanel={detailPanel}
        data={data}
        title={title}
        actions={[
          editLink
            ? {
                icon: Edit,
                tooltip: "ویرایش",
                onClick: (event, rowData) =>
                  window.open(editLink + rowData.id, "_blank"),
              }
            : null,
          handleRemove
            ? {
                icon: DeleteOutline,
                tooltip: "حذف",
                onClick: (event, rowData) => {
                  handleRemove(rowData.id);
                },
              }
            : null,
        ]}
        options={{
          pageSize: props.perPage ? props.perPage : 10,
          pageSizeOptions,
          actionsColumnIndex: -1,
          exportButton: needExport,
          // searchText: "جستجو",
          exportAllData: true,
          exportCsv: (columns, data) => {
            var fileName = (pdfName || title || "export") + "_" + momentJalai().format("jYYYY-jMM-jDD_HH-mm") + ".xlsx";
            generateXlsx(columns, data, title, fileName);
          },
          exportPdf: (columns, data) => {
            var fileName = pdfName + "_" + momentJalai().format("jYYYY-jMM-jDD_HH-mm") + ".pdf";
            generatePdf(columns, data, title, fileName, pdfOrientation);
          },
          defaultExpanded: true,
          headerStyle: {
            backgroundColor: "#01579b",
            color: "#FFF",
            border: "1px solid #cccccc",
          },
          cellStyle: {
            border: "1px solid #cccccc",
          },
        }}
        components={{
          Pagination: (paginationProps) => {
            const {
              onChangePage,
              onChangeRowsPerPage,
              ...restProps
            } = paginationProps;
            return (
              <TablePagination
                {...restProps}
                rowsPerPageOptions={pageSizeOptions}
                onPageChange={onChangePage}
                onRowsPerPageChange={onChangeRowsPerPage}
                onChangePage={onChangePage}
                onChangeRowsPerPage={onChangeRowsPerPage}
              />
            );
          },
        }}
      />
      <Dialog
        open={openRemove}
        onClose={() => {
          setOpenRemove(false);
          setSelectRemove(null);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"حذف"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            مطمئنی می خوای حذف کنی ؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenRemove(false);
              setSelectRemove(null);
            }}
            color="primary"
          >
            بی خیال
          </Button>
          <Button
            onClick={() => {
              handleRemove(selectRemove.id);
              setSelectRemove(null);
              setOpenRemove(false);
            }}
            color="primary"
            autoFocus
          >
            آره
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default React.memo(withRouter(MaterialTableRtl));
